import styled from "styled-components";

export const Img = styled.img`
  height: 100%;
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Spinner = styled.img`
  width: 80px;
  height: 80px;
`;
